import { PropsWithChildren } from 'react'
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/AppSidebar'
import Layout, { useAuth } from '@/components/Layout'
import { NotificationBell } from '@/components/NotificationBell'
import { UserMenu } from '@/components/UserMenu'
import { TutorialsIntroDialog } from '@/components/TutorialsIntroDialog'

function getSidebarDefault(): boolean {
  if (typeof document === 'undefined') return true
  // O shadcn sidebar salva o estado em cookie "sidebar_state"
  const match = document.cookie.match(/sidebar_state=(\w+)/)
  return match ? match[1] === 'true' : true
}

interface DashboardLayoutProps extends PropsWithChildren {
  schoolName?: string
}

export default function DashboardLayout({ children, schoolName }: DashboardLayoutProps) {
  const { user } = useAuth()
  const actualSchoolName = schoolName || user?.school?.name

  // Verifica se o usuário é owner ou manager para mostrar notificações
  const showNotifications = user && (user.role === 'owner' || user.role === 'manager')

  return (
    <Layout>
      <SidebarProvider defaultOpen={getSidebarDefault()}>
        <AppSidebar />
        <main className="flex-1 w-full overflow-x-hidden">
          <div className="bg-bewave-header border-b shadow-sm">
            <div className="flex h-14 items-center gap-4 px-4">
              <SidebarTrigger />
              <span className="text-sm font-medium text-foreground">{actualSchoolName}</span>
              <div className="flex-1" />
              <div className="ml-auto flex items-center gap-2">
                {showNotifications && user.school && (
                  <NotificationBell
                    userId={user.id}
                    schoolId={user.school.id}
                  />
                )}
                <UserMenu />
              </div>
            </div>
          </div>
          <div className="overflow-x-hidden">
            {children}
          </div>
        </main>
      </SidebarProvider>
      <TutorialsIntroDialog />
    </Layout>
  )
}
